/* src/app/modules/concept/orders/orders-list.component.css */
.orders-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.order-card {
  width: 90%;
}
.order-table-container {
  overflow-x: auto;
}
.full-width-table {
  width: 100%;
}
.mat-mdc-header-cell {
  background-color: var(--cf-brand-dark);
  color: white;
  font-weight: bold;
}
.mat-mdc-cell {
  padding: 12px;
}
tr.mat-mdc-row:hover {
  background-color: rgba(25, 118, 210, 0.1);
}
/*# sourceMappingURL=orders-list.component.css.map */
